// src/data/expertiseData.js
// 이미지 경로는 public/images/ 폴더에 평면 구조로 넣어주세요 (다른 홈페이지 이미지들과 같은 폴더).
// 파일이 없을 동안에도 카드가 깨지지 않도록 배경색이 폴백으로 깔립니다.

export const EXPERTISE_DATA = {
  'fuel-cell': {
    title: 'Fuel Cell Driven Smart Farm',
    tagline: '연료전지로 가동되는 에너지 자립형 스마트팜',
    heroImage: '/images/expertise-fuel-cell-hero.png',
    heroOverlay: false,
    description: {
      title: 'Fuel Cell Driven Smart Farm',
      paragraphs: [
        '수소 연료전지(Reformer → Buffer Tank → Purifier → High-Pressure Compressor) 라인을 통해 자체적으로 전력을 생산하고, 고압으로 압축된 수소는 동일 부지의 H2 충전 인프라와 연계됩니다.',
        '생산된 전력과 열은 건물 상부의 컨테이너형 스마트팜 및 Farm to Table 레스토랑 운영에 그대로 사용되어, 에너지 생산과 신선 농산물 소비가 한 공간에서 순환하는 도심형 모델을 구현합니다.'
      ]
    },
    categories: [
      {
        image: '/images/expertise-fuel-cell-1.jpg',
        title: '에너지 자립 시스템',
        description: '연료전지 발전으로 외부 전력 의존도를 낮추고 컨테이너형 스마트팜을 독립적으로 운영합니다.'
      },
      {
        image: '/images/expertise-fuel-cell-2.jpg',
        title: '열-전기 동시 활용',
        description: '발전 과정에서 발생하는 열을 냉난방에 재사용해 에너지 효율을 극대화합니다.'
      },
      {
        image: '/images/expertise-fuel-cell-3.jpg',
        title: '경제성 분석',
        description: 'LNG, 그린메탄올 등 연료원별 운영 비용을 비교해 최적의 에너지 믹스를 제안합니다.'
      }
    ]
  },
  'digital-twin-expertise': {
    title: 'Digital Twin for Remote Cultivation',
    tagline: '현장과 동일한 3D 환경에서 원격으로 재배를 제어합니다',
    heroImage: '/images/expertise-digital-twin-hero.png',
    heroOverlay: false,
    description: {
      title: 'Digital Twin for Remote Cultivation',
      paragraphs: [
        'AR 글래스를 착용한 사용자는 Tower Garden System의 실제 생장 데이터를 홀로그램 형태로 그 자리에서 바로 확인하고, 작물의 생육 시뮬레이션과 환경 데이터를 손짓 하나로 조작할 수 있습니다.',
        '현장의 센서 데이터, 생장 분석, 영양액 제어 정보가 디지털트윈 화면에 실시간으로 동기화되어, 원격에서도 마치 현장에 있는 것처럼 재배 환경을 교육하고 운영할 수 있는 협업 환경을 제공합니다.'
      ]
    },
    categories: [
      {
        image: '/images/expertise-digital-twin-1.jpg',
        title: '실시간 3D 동기화',
        description: '센서 데이터와 3D 모델을 실시간으로 동기화해 현장 상태를 그대로 재현합니다.'
      },
      {
        image: '/images/expertise-digital-twin-2.jpg',
        title: '원격 제어',
        description: '조명, 양액, 환경 제어를 디지털트윈 화면에서 직접 실행합니다.'
      },
      {
        image: '/images/expertise-digital-twin-3.jpg',
        title: '다지점 통합 관리',
        description: '여러 재배 컨테이너를 하나의 대시보드에서 통합 모니터링합니다.'
      }
    ]
  },
  'recipe-commercialization': {
    title: 'Cultivation Recipe Commercialization',
    tagline: '검증된 재배 레시피를 표준화하고 사업화합니다',
    heroImage: '/images/expertise-recipe-hero.png',
    heroOverlay: false,
    description: {
      title: 'Cultivation Recipe Commercialization',
      paragraphs: [
        'SyncAI 플랫폼이 모든 재배 컨테이너의 센서, 생장 이미지, 환경 제어 데이터를 하나로 통합하고, AI가 이를 분석해 작물별 생육 패턴을 데이터로 축적합니다.',
        '이렇게 검증된 데이터는 표준화된 재배 레시피로 정리되어, 실시간 데이터 통합·AI 기반 분석·지능형 제어·안전한 시스템 운영이라는 네 가지 원칙 위에서 안정적으로 사업화·확산될 수 있습니다.'
      ]
    },
    categories: [
      {
        image: '/images/expertise-recipe-1.jpg',
        title: '레시피 표준화',
        description: '작물별 최적 생육 조건을 데이터로 표준화합니다.'
      },
      {
        image: '/images/expertise-recipe-2.jpg',
        title: '전문가 협업',
        description: '재배 전문가의 노하우를 디지털 레시피로 전환합니다.'
      },
      {
        image: '/images/expertise-recipe-3.jpg',
        title: '품질 일관성',
        description: '표준 레시피 적용으로 수확물의 품질 편차를 최소화합니다.'
      }
    ]
  }
};
